import { z } from "zod";
// Only allow letters, spaces, and common punctuation in address
const addressRegex = /^[A-Za-z\s,.'-]+$/;

// Function that creates schema with localized messages
export const registerSchema = (t: (key: string, options?: any) => string) => {
  return z.object({
    name: z
      .string()
      .min(1, t("shared.branchForm.required"))
      .min(3, t("shared.branchForm.minLength", { min: 3 }))
      .max(50, t("shared.branchForm.maxLength", { max: 50 }))
      .regex(addressRegex, t("shared.branchForm.invalidBranchName")),

    city_id: z.string().min(1, t("shared.branchForm.required")),
    contact_person_first_name: z.string()
      .min(1, t("shared.branchForm.required"))
      .min(2, t("shared.branchForm.minLength", { min: 2 }))
      .max(20, t("shared.branchForm.maxlengthDynamic", { max: 20 }))
      .regex(addressRegex, t("shared.branchForm.invalidBranchName")),
    contact_person_last_name: z.string()
      .min(1, t("shared.branchForm.required"))
      .min(2, t("shared.branchForm.minLength", { min: 2 }))
      .max(20, t("shared.branchForm.maxlengthDynamic", { max: 20 }))
      .regex(addressRegex, t("shared.branchForm.invalidBranchName")),
    contact_person_email: z
      .string()
      .min(1, t("shared.branchForm.required"))
      .email(t("shared.branchForm.invalidEmail")),
    type: z.string().min(1, t("shared.branchForm.required")),
    contact_person_mobile: z.string().min(1, t("shared.branchForm.required")),
    mobile_number_prefix: z.string()
  });
};



export interface RegisterFormValues {
    name: string;
    type: string;
    city_id: string;
    contact_person_first_name: string;
    contact_person_last_name: string;
    contact_person_email: string;
    contact_person_mobile: string;
    mobile_number_prefix: string;
  } 